import { HURRICANES_ACCESSIBLE_NAME } from '../../config/hurricanes.config';

const HurricanesPageContainer = ({ children, isDesktop = false }) => (
  <section
    aria-label={HURRICANES_ACCESSIBLE_NAME}
    className={`hurricanes d-flex w-100 flex-column gap-2${isDesktop ? ' h-100 min-h-0' : ''}`}
  >
    {children}
  </section>
);

export default HurricanesPageContainer;
